import React from 'react';
import { formatText, HtmlText } from 'core/i18n';
import BlockWrapper from 'components/blockWrapper/blockWrapper';
import { Cno } from 'components/professionTypes/cno';
import { recordEventCustomOnly } from 'utilities/uTagging';
import { CompanyNameInput } from '../../components/companyNameInput';
import { FiocTgssConsent } from '../../components/FiocTgssConsent';
import MessageBox from 'components/commons/MessageBox/MessageBox';

export const ReducedQuestions = ({
    disabled,
    formActions,
    onHandleSave,
    shouldRenderTgssQuestion,
    showCompanyNameWarning,
    setShowCompanyNameWarning,
    userProfile,
    userProfileForm,
}) => {
    const { employed_company, cno1_profession_id, cno2_profession_id } = userProfile;

    return (
        <section className="fioc-account-type">
            <BlockWrapper position={0} visible={true} cancelDefaultFocusBehavior>
                <Cno disabled={disabled} handleSave={onHandleSave} />
            </BlockWrapper>

            <BlockWrapper
                position={1}
                visible={false}
                firstValue={employed_company || cno1_profession_id || cno2_profession_id}
            >
                <div className="fioc-account-type__company-name">
                    <CompanyNameInput
                        formActions={formActions}
                        handleOnFocus={() => {
                            setShowCompanyNameWarning(true);
                            recordEventCustomOnly({
                                accionEvento: 'nombre de la empresa',
                                categoriaEvento: 'interaccion en tu actividad',
                            });
                        }}
                        isValidated={() => {
                            setShowCompanyNameWarning(false);
                            onHandleSave('companyName', employed_company);
                        }}
                        label={formatText('field-companyName')}
                        profileModel="userProfile.employed_company"
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                    />
                </div>
                {showCompanyNameWarning && (
                    <div className="fioc-account-type__messages__company-name">
                        <MessageBox
                            boxColor="yellow"
                            iconColor="warning-yellow"
                            titleText={formatText('field-companyNameWarningTitle')}
                            contentText={HtmlText(formatText('field-companyNameWarningDescription'))}
                        />
                    </div>
                )}
            </BlockWrapper>

            {!shouldRenderTgssQuestion && (
                <BlockWrapper position={2} visible={false} firstValue={employed_company}>
                    <FiocTgssConsent
                        formActions={formActions}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                    />
                </BlockWrapper>
            )}
        </section>
    );
};
